<template>
  <aside id="slider" class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- Sidebar user panel -->
      <a style="cursor: pointer" @click="toProfile()">
        <div class="user-panel">
          <div class="pull-left image">
            <img :src="profileImg" class="img-circle" alt="User Image" />
          </div>
          <div class="pull-left info">
            <p>{{ fullname }}</p>
            <a href="#">
              <i class="fa fa-circle" :style="`color:${currentUser.state.color}`"></i>
              {{ currentUser.state.name }}
            </a>
          </div>
        </div>
      </a>
      <!-- /.search form -->
      <!-- sidebar menu: : style can be found in sidebar.less -->
      <ul data-widget="tree" class="sidebar-menu">
        <!-- <li class="header">MAIN NAVIGATION</li> -->

        <li @click="closeToggle" v-bind:class="[$route.name == 'Dashboard'  ||$route.name == 'DashboardOperator' ?  'active': '']">
          <router-link to="/Operator/Dashboard">
            <i class="fa fa-home"></i>
            <span>หน้าแรก</span>
            <span class="pull-right-container">
              <!-- <small class="label pull-right bg-green">new</small> -->
            </span>
          </router-link>
        </li>

        <li
          v-if="permission.Manage_mobile"
          v-bind:class="[$route.name == 'Manage_mobileOperator' || $route.name == 'Operator_Manage_mobile' || $route.name == 'Add_promotion_mobile' || $route.name == 'Add_file_promotion' ?  'active': '']"
          >
          <router-link to="/Operator/Manage_mobileOperator">
            <i class="fa el-icon-mobile"></i>
            <span>จัดการข้อมูลรายการส่งเสริมการขายโทรศัพท์เคลื่อนที่</span>
            <span class="pull-right-container">
              <!-- <small class="label pull-right bg-green">new</small> -->
            </span>
          </router-link>
        </li>

        <li
          v-if="permission.Manage_internet"
          v-bind:class="[$route.name == 'Operator_Manage_internet'  ||$route.name == 'Add_promotion_internet' || $router.name == 'Add_file_promotion_internet'?  'active': '']"
          >
          <router-link to="/Operator/Manage_internet">
            <i class="fa el-icon-monitor"></i>
            <span>จัดการข้อมูลรายการส่งเสริมการขายอินเทอร์เน็ตความเร็วสูงประจำที่</span>
            <span class="pull-right-container">
              <!-- <small class="label pull-right bg-green">new</small> -->
            </span>
          </router-link>
        </li>

        <li v-if="permission.Upload_save" 
        v-bind:class="[$route.name == 'Upload_saveMonthly' || $route.name == 'Add_uploadsave' || $route.name == 'Confirm_promotion_Monthlymobile' ?  'active': '']">
          <router-link to="/Operator/Upload_saveMonthly">
            <i class="fa el-icon-document-checked"></i>
            <span>นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล</span>
            <span class="pull-right-container">
              <!-- <small class="label pull-right bg-green">new</small> -->
            </span>
          </router-link>
        </li>

        <!-- รายงานรายการส่งเสริมการขายบริการอินเทอร์เน็ตความเร็วสูงประจ าที่ในรูปแบบเทคโนโลยีต่างๆ  -->
        <li v-if="permission.Reportview_promotion" 
        v-bind:class="[$route.name == 'Reportview_promotion'  ?  'active': '']">
          <router-link to="/Operator/Reportview_promotion">
            <i class="fa fa-bar-chart-o"></i>
            <span>รายงานจำนวนผู้เข้าชมข้อมูลรายการส่งเสริมการขายจำแนกตามการให้บริการ</span>
            <span class="pull-right-container">
              <!-- <small class="label pull-right bg-green">new</small> -->
            </span>
          </router-link>
        </li>

        <li v-if="permission.User_behavior"
          v-bind:class="[$route.name == 'User_behavior_operator' ? 'active' : '']"
        >
          <router-link to="/Operator/User_behavior">
            <i class="fa fa-bar-chart-o"></i>
            <span>รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ </span>
            <span
              class="pull-right-container"
              style="display:none!important;"
            ></span>
          </router-link>
        </li>

        <li v-if="permission.Contact_admin"
          v-bind:class="[$route.name == 'Contact_admin' ? 'active' : '']"
        >
          <router-link to="/Operator/Contact_admin">
            <i class="fa el-icon-message"></i>
            <span>แจ้งปัญหาการใช้งาน</span>
            <span
              class="pull-right-container"
              style="display:none!important;"
            ></span>
          </router-link>
        </li>
      </ul>
    </section>
    <!-- /.sidebar -->
  </aside>
</template>
<style>
/* .fa-angle-left.fa-angle-rg {
  -webkit-transform: rotate(10deg)!important;
    transform: rotate(10deg)!important;
} */
</style>

<script>
import { mapState } from "vuex";
// import VASlideItem from "../template/VASlideItem";

export default {
  data() {
    return {
      arrShow: true,
      permission : {
        Manage_mobile : false,
        Manage_internet : false,
        Upload_save : false,
        Reportview_promotion : false,
        User_behavior : false,
        Contact_admin : false
      }
    };
  },
  methods: {
    arrShoww() {
      if (this.arrShow) {
        this.arrShow = false;
      } else {
        this.arrShow = true;
      }
    },
    closeToggle() {
      this.arrShow = true;
    },
    toProfile() {
      this.$router.push({ name: "ProfileOperator" });
    }
  },
  name: "va-slider",
  mounted(){
    this.permission.Manage_mobile = this.store_permission.Manage_mobile ? this.store_permission.Manage_mobile.includes(...['add','edit','delete']) : false
    this.permission.Manage_internet = this.store_permission.Manage_internet ? this.store_permission.Manage_internet.includes(...['add','edit','delete']) : false
    this.permission.Upload_save = this.store_permission.Upload_save ? this.store_permission.Upload_save.includes('true') : false
    this.permission.Reportview_promotion = this.store_permission.Reportview_promotion ? this.store_permission.Reportview_promotion.includes('true') : false
    this.permission.User_behavior = this.store_permission.User_behavior ? this.store_permission.User_behavior.includes('true') : false
    this.permission.Contact_admin = this.store_permission.Contact_admin ? this.store_permission.Contact_admin.includes('true') : false
  },
  computed: {
    ...mapState({
      fullname:store => store.Menu.fullname,
      profileImg:store => store.Menu.profileImg,
      currentUser: store => store.Menu.main,
      store_permission : store => store.Menu.permission
    }),
    currentRoute: function() {
      let routeName = this.$route.name;
      //if(routeName == 'Report_sell_internet' || $route.name ==  'Report_sell_mobile'){
      if (
        (routeName == "Report_sell_internet" && this.arrShow) ||
        (routeName == "Report_sell_mobile" && this.arrShow)
      ) {
        return "active menu-open";
      } else {
        return "";
      }

      //return this.content['cravings'] ? 'fa-checkbox-marked' : 'fa-checkbox-blank-outline';
    }
  },
  components: {
    // "va-slide-item": VASlideItem
  }
};
</script>
